import React from 'react';
import classNames from 'classnames';
import { SdfTab, SdfTabGroup } from '@waypoint/react-components';
import { ComponentManager } from '@adp-wfn/mdf-core';
import { ISidebarItemData } from './MDFSidebar';
import { iconMapper } from '../util/iconMapper';
import logger from '../util/logger';
import { isEqual } from 'lodash';

export interface IVerticalNavState {
  canNavigate?: boolean;
  menuOpen?: boolean;
  selectedItem?: number;
}

export interface IVerticalNavProps {
  active?: boolean;
  alertNum?: number;
  canNavigate?: boolean;
  className?: any;
  data: ISidebarItemData[];
  id?: string;
  mainLabel?: string;
  navigationLabel?: string;
  selectedItem: number;
  title?: any;
  useMainRole?: boolean;
  useNavigationRole?: boolean;
  onChange?: (index: number) => void;
}

export class MDFVerticalNav extends React.Component<IVerticalNavProps, IVerticalNavState> {
  constructor(props) {
    super(props);

    this.state = {
      menuOpen: false,
      canNavigate: !(this.props.canNavigate === false)
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const nextState: any = {};

    if (!isEqual(prevState.canNavigate, !(nextProps.canNavigate === false))) {
      nextState.canNavigate = nextProps.canNavigate;

      if (nextState.canNavigate && (!isEqual(prevState.selectedItem, nextProps.selectedItem))) {
        nextState.menuOpen = false;
      }
    }

    return nextState;
  }

  getSelectedItem = () => {
    const data = this.props.data;
    let selectedIndex = 0;

    data.forEach((dataItem, i) => {
      if (dataItem.active) {
        selectedIndex = i;
      }
    });

    return selectedIndex;
  };

  handleMenuToggle = () => {
    this.setState({
      menuOpen: !this.state.menuOpen
    });
  };

  handleSelect = (selectedItem) => {
    console.log('MDFVerticalNav.handleSelect(): Entering. selectedItem = ', selectedItem);

    if (this.state.canNavigate) {
      console.log('MDFVerticalNav.handleSelect(): Setting state. selectedItem.value = ', selectedItem.value);

      if (this.props.onChange) {
        this.props.onChange(selectedItem.value);
      }
    }
  };

  private static renderCustomItem(item: ISidebarItemData) {
    const View = ComponentManager.getComponent(item.customItem);

    return <View/>;
  }

  render() {
    logger('MDFVerticalNav.render(): Entering. state = ', this.state);
    logger('MDFVerticalNav.render(): Entering. props = ', this.props);

    const data = this.props.data;
    const className = this.props.className;
    // Get navigation views by the selectedItemIndex
    const viewComponent = ComponentManager.getComponent(data[this.props.selectedItem].view);
    const rootClasses = {
      'left-nav-framework': true,
      'left-nav-framework--menu-open': this.state.menuOpen
    };

    const mainRole = this.props.useMainRole ? { role: 'main', 'aria-label': this.props.mainLabel ?? 'Vertical navigation component main section' } : {};
    const navigationRole = this.props.useNavigationRole ? { role: 'navigation', 'aria-label': this.props.navigationLabel ?? 'Vertical navigation component navigation section' } : {};

    return (
      <div className={classNames(className, rootClasses)}>
        <div className="left-nav-framework__container flex">
          <div className="flex-none" { ...navigationRole }>
            <SdfTabGroup
              vertical={true}
              onSdfChange={(e) => this.handleSelect(e.detail)}
            >
              {
                data.map((dataItem, i) => (
                  <SdfTab
                    key={dataItem.key}
                    id={dataItem.id}
                    value={i}
                    icon={iconMapper(dataItem.icon) ? iconMapper(dataItem.icon) : undefined}
                    active={i === this.props.selectedItem ? true : undefined}
                  >
                    {dataItem['customItem'] ? MDFVerticalNav.renderCustomItem(dataItem) : <span>{dataItem.label}</span>}
                  </SdfTab>
                ))
              }
            </SdfTabGroup>
          </div>
          <div className="flex-auto min-h-screen" { ...mainRole }>
            <div className="left-nav-framework__top-bar">
              <h1 className="left-nav-framework__title">
                {this.props.title}
              </h1>
            </div>
            <div className="flex flex-col min-h-screen">
              <div className="flex flex-col flex-auto">
                {React.createElement(viewComponent)}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
